import { render, staticRenderFns } from "./registrationQuery.vue?vue&type=template&id=55272cc6&scoped=true"
import script from "./registrationQuery.vue?vue&type=script&lang=js"
export * from "./registrationQuery.vue?vue&type=script&lang=js"
import style0 from "./registrationQuery.vue?vue&type=style&index=0&id=55272cc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55272cc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55272cc6')) {
      api.createRecord('55272cc6', component.options)
    } else {
      api.reload('55272cc6', component.options)
    }
    module.hot.accept("./registrationQuery.vue?vue&type=template&id=55272cc6&scoped=true", function () {
      api.rerender('55272cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/registrationQuery/views/registrationQuery.vue"
export default component.exports